import { apiClient } from '@api/apiClient';
import { logError } from '@utils/errorLogging';

import { OrderFlagStateDefinition } from './types';

export const getOrderFlagStateDefinitions = async (): Promise<
  OrderFlagStateDefinition[]
> => {
  try {
    const result = await apiClient.get<OrderFlagStateDefinition[]>(
      'flag/StateDefinitions',
    );
    return result as unknown as OrderFlagStateDefinition[];
  } catch (e) {
    logError('getOrderFlagStateDefinitions', e as Error);
    return [];
  }
};
